exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-37163ebb]{display:block;text-align:left}[data-v-37163ebb] .el-form-item__label{line-height:38px}[data-v-37163ebb] .el-tabs__header{margin:0}[data-v-37163ebb] .el-tabs__header .el-tabs__item{height:60px;line-height:60px}[data-v-37163ebb] .el-tabs__header .el-tabs__nav{margin-left:20px}\n", ""]);

// exports
